export default __webpack_public_path__ + "static/media/rose-732361_1280.3656303d.png";